<template>
  <div class="p-8 text-center">
    <h2 class="text-2xl font-bold mb-4">{{ moduleDisplayName.charAt(0).toUpperCase() + moduleDisplayName.slice(1) }}
      Limit Reached</h2>
    <p class="mb-6 text-gray-700 text-base whitespace-pre-line">
      You have reached the maximum of {{ moduleData.subscription_details.quantity }} {{ moduleDisplayName }} allowed with your
      current plan.<br>
      To add more, purchase additional add-ons.<br>
      <em>Each add-on increases your limit by {{ moduleData.subscription_details.block_size }} {{ moduleDisplayName }}.</em>
    </p>
    <div class="flex justify-center gap-4">
      <button class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md" @click="onUpgrade">
        Purchase Add-ons
      </button>
      <button class="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-6 rounded-md" @click="onClose">
        Close
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    moduleData: { type: Object, required: true },
    moduleDisplayName: { type: String, required: true }
  },
  methods: {
    onUpgrade() {
      // Redirect to billing portal with subscription ID as a query param
      let url = '/billing/portal';
      if (this.moduleData?.subscription_details?.id) {
        url += `?subscription_id=${encodeURIComponent(this.moduleData?.subscription_details?.id)}`;
      }
      window.location.href = url;

    },
    onClose() {
      this.$modal.hide('addon-action-overlay');
    }
  }
};
</script>
